import { useSelector } from 'react-redux';
import { selectCustomizedControlledTransactions } from '../../selectors';

export const useCustomizedControlledTransactions = () => {
  return useSelector(selectCustomizedControlledTransactions);
};
